const icon = {
	group: "inline",
	inline: true,
	attrs: {
		code: { default: null },
		svg: { default: null },
		color: { default: null },
	},
};

export default icon;
